<template>
  <div>
    <b-row>
      <b-col cols="12" sm="12">
        <b-card :title="$t('reception.patient-card-detalis')">
          <div>
            <h5 class="my-2">
              <b>{{ $t("common.name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ generalPatientTestInfo.patient_card.patient.name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.companion-name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ generalPatientTestInfo.patient_card.full_companion_name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.companion-phone") }}:</b>
              <p class="mx-2 d-inline">
                {{ generalPatientTestInfo.patient_card.companion_phone }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.card-type") }}:</b>
              <p class="mx-2 d-inline">
                {{ generalPatientTestInfo.patient_card.type }}
              </p>
            </h5>

            <h5 class="my-2">
              <b>{{ $t("reception.patient-case") }}:</b>
              <p class="mx-2 d-inline">
                {{ generalPatientTestInfo.patient_card.patient_case }}
              </p>
            </h5>
          </div>

          <hr class="invoice-spacing" />
          <h2 class="my-2">{{ $t("reception.patient-updates") }}</h2>
          <div>
            <h5 class="my-2">
              <b>{{ $t("reception.date-of-last-update") }}:</b>
              <p class="mx-2 d-inline">
                {{ generalPatientTestInfo.patient_card.updated_at }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.date-of-last-update") }}:</b>
              <p class="mx-2 d-inline">
                {{ generalPatientTestInfo.patient_card.updated_at }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.patient-info-created-at") }}:</b>
              <p class="mx-2 d-inline">
                {{ generalPatientTestInfo.patient_card.created_at }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.card-no") }}:</b>
              <p class="mx-2 d-inline">
                {{ generalPatientTestInfo.patient_card.card_no }}
              </p>
            </h5>
          </div>
        </b-card>
        <b-card :title="$t('lab.Patient Test Details')">
          <div>
            <b-table
              :items="data"
              responsive
              :fields="tableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(test_name)="data">
                {{ data.item.test.name }}
              </template>
              <template #cell(normalRange)="data">
                >{{ getNestedProperty(data.item, 'writeTest.min') }} - {{ getNestedProperty(data.item, 'writeTest.max') }}

              </template>
              <template #cell(unit)="data">
                {{ data.item.unit ? data.item.unit.name : "" }}
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">Showing 1 to 10 of tests</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="index()"
                >
                  <b-pagination
                    v-model="page"
                    :total-rows="dataCount"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
        <b-card :title="$t('lab.Patient Test Details')">
          <vue-apex-charts
            type="line"
            height="100%"
            width="100%"
            :options="options"
            :series="series"
            :markers="true"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormInput,
  BTable,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    BRow,
    BTable,
    BPagination,
    BCol,
    BLink,
    BFormInput,
    BFormGroup,
    BCard,
    BSpinner,
    BCardText,
    BButton,
    VueApexCharts,
  },
  data() {
    return {
      data: [],
      generalPatientTestInfo: {},
      take: 10,
      loading: true,
      page: 1,
      tableColumns: [
        {
          key: "test_name",
          sortable: true,

          label: this.$t("common.name"),
        },
        {
          key: "result",
          sortable: true,

          label: this.$t("lab.result"),
        },
        {
          key: "unit",
          sortable: true,

          label: this.$t("lab.unit"),
        },
        {
          key: "normalRange",
          sortable: true,

          label: this.$t("lab.normalRange"),
        },
        {
          key: "result_as_to_normal_range",
          sortable: true,

          label: this.$t("lab.resultAsToNormalRange"),
        },
        {
          key: "discount",
          sortable: true,

          label: this.$t("common.discount"),
        },
        {
          key: "price_after_discount",
          sortable: true,

          label: this.$t("lab.price_after_discount"),
        },
        {
          key: "created_at",
          sortable: true,

          label: this.$t("common.date"),
        },
      ],
    };
  },
  mounted() {
    this.getPatientTest();
  },

  methods: {
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      if (typeof result === "string" && result.startsWith("\\")) {
        return defaultValue;
      }
      // console.log("result", result);
      return result;
    },
    formatDate(date) {
      if (date) {
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },

    async getPatientTest() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patientCardTest?filter[test_id]=${this.$route.params.id}&filter[patient_card_id]=${this.$route.params.patientCardId}&page=${this.page}&take=${this.take}&sort=-id&include=test,patientCard,unit`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.generalPatientTestInfo = this.all_data.data[0];
      this.data = this.all_data.data;
      const dataWithNormalRange = await Promise.all(
        this.data.map(async (patientTest, index) => {
          // console.log("patientTest", patientTest.test_id);
          const normalRange = await this.getNormalRange(patientTest.test_id);
          // console.log("normalRange", normalRange);
          return {
            ...patientTest,
            test: normalRange,
          };
        })
      );

      this.data = dataWithNormalRange;
      // console.log(
      //   "this.data.test.normal_ranges",
      //   this.data[0].test.normal_ranges
      // );
      // console.log("this.generalPatientTestInfo.patient", this.generalPatientTestInfo.patient);
      this.data.map((item) => {
        const writeTest = this.getPatientNormalRangeByAgeAndGender(
          this.calculateAge(this.generalPatientTestInfo.patient.birth_date),
          this.generalPatientTestInfo.patient.gender,
          item.test.normal_ranges
        );
        // console.log("writeTest", writeTest);
        item.writeTest = writeTest;
      });
      console.log("this.writeTest", this.data);

      //   const categories = this.data.map((item) => {
      //     this.date = item.created_at.split(' ')[0];

      //     return item.created_at.split(' ')[1];
      //   }); // Extracting dates
      //   const dataValues = this.data.map((item) => parseFloat(item.result)); // Extracting values

      //   // Constructing the options object
      //   this.options = {
      //     chart: {
      //       id: 'vuechart-example',
      //       toolbar: {
      //         show: false,
      //       },
      //       zoom: {
      //         enabled: false,
      //       },
      //     },
      //     markers: {
      //       size: [7, 7],
      //     },
      //     xaxis: {
      //       categories: categories,
      //     },
      //   };

      //   // Constructing the series object
      //   this.series = [
      //     {
      //       name: 'series-1',
      //       data: dataValues,
      //     },
      //   ];
      //   this.loading = false;
    },
    async getNormalRange(testId) {
      await this.getPatient(`/test/${testId}?include=normalRanges`);
      const testWithNormalRange = this.all_data;
      // console.log("testWithNormalRange", testWithNormalRange);
      return testWithNormalRange;
    },
    getPatientNormalRangeByAgeAndGender(
      patientAge,
      patientGender,
      normalRanges
    ) {
      let writeTest = null;
      if (Array.isArray(normalRanges)) {
        normalRanges.map((normalRange) => {
          if (
            normalRange.min_age <= patientAge &&
            normalRange.max_age >= patientAge &&
            normalRange.gender == patientGender
          ) {
            writeTest = normalRange;
          }
        });
      } else {
        console.error("normalRanges is not an array:", normalRanges);
      }
      // console.log("writeTest", writeTest);
      return writeTest;
    },
    calculateAge(birth_date) {
      // birth_date = "1950-01-01";
      const today = new Date();
      const birthDate = new Date(birth_date);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      console.log("age", age);
      return age;
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
